import publicTemplate from './views/layout/public.html';

import { AccountsRouterStates } from './routes/accounts.route';
import { DashboardRouterStates } from './routes/dashboard.route';
import { AdministrationRouterStates } from './routes/administration.route';
import { ValueSeriesStates } from './routes/valueseries.route';
import { ErroneousStatementsStates } from './routes/erroneousstatements.route';
import { StatementsRouterStates } from "./routes/statements.route";
import { IntradaysRouterStates } from "./routes/intradays.route";
import { ExportRouterStates } from "./routes/export.route";

export function routerConfig($stateProvider, $urlRouterProvider) {
    'ngInject';
    $urlRouterProvider.when('', '/app/dashboard');
    $stateProvider.state('index', {
        url: '',
        abstract: true,
        params: {
            requiresAuthentication: false
        },
    }).state('public', {
        url: '/public',
        abstract: true,
        templateUrl: publicTemplate,
        defaultChild: 'public.login'
    }).state('public.login', {
        url: '/login',
        templateUrl: 'app/views/dashboard/dashboard.html',
        controller: 'fsLoginController',
        controllerAs: 'vm'
    }).state('public.logout', {
        url: '/logout',
        resolve: {
            logout: fsLoginController => fsLoginController.logout()
        }
    }).state('app', {
        url: '/app',
        abstract: true,
        templateUrl: 'app/views/layout/app.html',
        controller: 'MainController',
        controllerAs: 'vm',
        params: {
            requiresAuthentication: true
        },
    });

    new ExportRouterStates($stateProvider).defineStates();

    new AccountsRouterStates($stateProvider).defineStates();

    new DashboardRouterStates($stateProvider).defineStates();

    new AdministrationRouterStates($stateProvider).defineStates();

    new ValueSeriesStates($stateProvider).defineStates();

    new ErroneousStatementsStates($stateProvider).defineStates();

    new StatementsRouterStates($stateProvider).defineStates();

    new IntradaysRouterStates($stateProvider).defineStates();
}
